<template>
    <el-container>
        <el-main >
            <el-select placeholder="" size="small" placeholder="机构" v-model="orgCode" @change="changeOrg" style="margin-left: 15px;">
                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
            </el-select>
            <br>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addCommodity" style="margin-left: 15px;" class="but-cls">添加试听商品</el-button>
            <el-dialog :visible.sync="showCommodity" width="60%"  top="10vh" :close-on-click-modal=false :before-close="handleDialogClose" >
               <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                   <el-row >
                       <el-col :span="7" class="cls-col" v-if="orgCode == 'eblcu'">
                           <el-form-item label="所属机构" prop="ccId">
                               <el-select placeholder="" size="small" placeholder="机构" v-model="searchData.orgCode" >
                                   <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                               </el-select>
                           </el-form-item>
                       </el-col>
                       <el-col :span="7" class="cls-col"  v-if="loginOrgCode != 'blcuonline'">
                           <el-form-item label="商品分类" prop="ccId">
                               <el-cascader
                                   expand-trigger="hover"
                                   change-on-select="true"
                                   size="small"
                                   clearable
                                   :options="categoryOptions"
                                   :props="{ value: 'ccId', label: 'ccName'}"
                                   v-model="selectedCategory"
                                   @change="changeCategory">
                               </el-cascader>
                           </el-form-item>
                       </el-col>
                       <el-col :span="7" class="cls-col">
                           <el-form-item label="课程名称" prop="courseName">
                               <el-input v-model="searchData.courseName" placeholder="课程名称" size="small" style="width: 80%"></el-input>
                           </el-form-item>
                       </el-col>
                   </el-row>
                   <el-form-item >
                       <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
                       <el-button type="success"  size="small" icon="el-icon-search" @click="saveRecommendCommodity()">提交</el-button>
                   </el-form-item>
               </el-form>
               <el-table
                       :data="commodityData"
                       @selection-change="handleSelectionChange"
                       border
                       ref = "multipleTable"
                       highlight-current-row
                       style="width: 100%; margin-bottom: 20px;"

               >
                   <el-table-column
                           type="selection"
                           width="55">
                   </el-table-column>
                   <el-table-column
                           type="index"
                           label="序号"
                           width="50"
                           fixed="left"
                   >
                   </el-table-column>
                   <el-table-column
                           prop="courseName"
                           fixed
                           label="商品名称"
                   >
                   </el-table-column>
                   <el-table-column
                       prop="orgName"
                       label="所属机构"
                   >
                   </el-table-column>
                   <el-table-column
                           prop="ccName"
                           label="商品分类"
                           v-if="loginOrgCode != 'blcuonline'"
                   >
                   </el-table-column>
                   
                   <el-table-column
                           prop="preferential"
                           label="现价">
                   </el-table-column>
                   
                   <el-table-column
                           prop="validity"
                           label="课程有效日期"
                           :formatter="monthFormat"
                   >
                   </el-table-column>
                   <el-table-column
                       prop="lessonType"
                       label="授课类型"
                       :formatter="f_lessonType"
                       v-if="loginOrgCode != 'blcuonline'"
                   >
                   </el-table-column>
                   <el-table-column
                           prop="persionNum"
                           label="报名人数">
                   </el-table-column>
                   <el-table-column
                       prop="createTime"
                       label="创建时间"
                       :formatter="dateFormat"
                       width="200"
                   >
                   </el-table-column>
               </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        :current-page.sync="currentPage"
                        @current-change="handleCurrentChange"
                        style="margin-top: -5px; float: right; margin-right: 10px">
                </el-pagination>

           </el-dialog>
            <el-table
                    :data="recommendCommodityData"
                    border
                    highlight-current-row
                    style="width: 100%; margin-bottom: 20px;">
                <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                        fixed="left"
                >
                </el-table-column>
                <el-table-column
                        prop="courseName"
                        fixed
                        label="课程名称"
                >
                </el-table-column>
                <el-table-column
                        prop="orgName"
                        label="所属机构"
                >
                </el-table-column>
                <el-table-column
                        prop="ccName"
                        label="课程分类"
                        v-if="loginOrgCode != 'blcuonline'"
                >
                </el-table-column>
                <el-table-column
                    prop="lessonType"
                    label="授课类型"
                    :formatter="f_lessonType"
                    v-if="loginOrgCode != 'blcuonline'"
                >
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="创建时间"
                        :formatter="dateFormat"
                        width="200"
                >
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="排序"
                    width="80"
                    align="center"
                >
        
                    <template slot-scope="{row,$index}">
                        <input class="edit-cell" ref="myInput" :id="['input'+row.commodityId]"  v-if="showEdit[row.commodityId]" @blur="changeRecommendSort(row)"  v-model="row.auditionSort" >
                        <span v-if="!showEdit[row.commodityId]" @click="handleEdit($index, row)">{{row.auditionSort}}</span>
                        <!--<el-tag type="primary" close-transition v-if="!showEdit[row.commodityId]" @click="handleEdit($index, row)"> {{row.sort}}</el-tag>-->
                    </template>
                </el-table-column>
                <el-table-column
                    prop="recommendSort"
                    label="机构排序"
                    width="80"
                    align="center"
                    v-if="false"
                >
                    <template slot-scope="{row,$index}">
                        <input class="edit-cell" v-if="showEdit[row.commodityId]" v-model="row.recommendSort" >
                        <span v-if="!showEdit[row.commodityId]">{{row.recommendSort}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import {dateFormat,monthFormat} from '@/api/utils.js'

    const formData = {

    };
    export default {
        data() {
            return {
                org: [],
                orgCode: '',
                loginOrgCode: '',
                formData: JSON.parse(JSON.stringify(formData)),
                total: 0,
                commodityData: [],
                searchData: {
                    size: 0,
                    page: 1,
                    courseName: "",
                    ccId: "",
                    commodityStatus: "",
                    isAudition: 1,
                    orgCode: "",
                    pccId: "",
                    isView: '',
                },
                showCommodity: false,
                currentPage: 1,
                recommendCommodityData: [],
                courseData:[],
                courseChild: [],
                courseChildData : {},
                showEdit: [],
                recommendCommodity: [],
                currentPageCommodity: [],
                pageSize:10,
                multipleSelection: [],
                selectedCategory: [],
                categoryOptions: [],
                showEdit: [],
            }
        },
        watch:{
            commodityData:function(){
                this.$nextTick(function(){
                    this.commodityData.forEach(row => {
                        if(this.recommendCommodity.indexOf(row.commodityId) > -1){
                            this.$refs.multipleTable.toggleRowSelection(row);
                        }
                    });
                });
            }
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].commodityId;
                }
            },
            handleCurrentChange(val) {
                this.changeRecommendCommodity();
                this.search(val);
            },
            handleDialogClose() {
                this.showCommodity = false;
                this.$refs["searchDate"].resetFields();
                  this.searchData.pccId = '';
                  this.selectedCategory = [];
            },
          handleEdit(index, row) {
            this.showEdit[row.commodityId] = true;
            this.searchRecommendCommodity();
            setTimeout(function() {
              document.getElementById("input"+row.commodityId).focus();
            }, 100);
          },
          changeRecommendSort(val) {
            const reg = /^\d{1,3}$/;
            if (!reg.test(val.auditionSort)) {
              this.$message.error('最多输入3位数字');
              return;
            }
            this.updateSort(val);
          },
          updateSort(row) {
            let params = {
              commodityId: row.commodityId,
              orgCode: this.orgCode,
              recommendSort: row.recommendSort
            };
            https.fetchPost("/commodityInfo/updateRecommendSortByCommodityId",params ).then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == '200') {
                this.$message({
                  message: '排序成功',
                  type: 'success'
                });
                this.showEdit[row.commodityId] = false;
                this.searchRecommendCommodity(this.orgCode);
              } else {
                this.$message.error('添加失败:' + msg);
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          },
            changeRecommendCommodity() {
                for(let index in this.currentPageCommodity) {
                    if(this.multipleSelection.indexOf(this.currentPageCommodity[index]) > -1) {
                        if(!(this.recommendCommodity.indexOf(this.currentPageCommodity[index]) > -1)) {
                            this.recommendCommodity.push(this.currentPageCommodity[index]);
                        }
                    } else {
                        let i = this.recommendCommodity.indexOf(this.currentPageCommodity[index])
                        if(i > -1) {
                            this.recommendCommodity.splice(i, 1);
                        }
                    }
                }
            },
            handleSizeChange() {},
            f_status(row, column, cellValue, index) {
                if(cellValue == "0") {
                    return "已下架";
                } else {
                    return "已上架";
                }
            },
          f_lessonType(row, column, cellValue, index) {
            if(cellValue == "1") {
              return "直播";
            }
            if(cellValue == "3") {
              return "面授";
            }
            if(cellValue == "2") {
              return "录播";
            }
            if(cellValue == "4") {
              return "录播+直播";
            }
            return "其他"
          },
            handleEdit(index, row) {
                this.showEdit[row.commodityId] = true;
                this.searchRecommendCommodity();
            },
            changeSort(val) {
                const reg = /^\d{1,3}$/;
                if(!reg.test(val.auditionSort)) {
                    this.$message.error('最多输入3位数字');
                    return;
                }
                this.updateSort(val)
            },
            updateSort(row) {
                let params = {
                  commodityId: row.commodityId,
                  auditionSort: row.auditionSort
                };
                https.fetchPost("/auditionCommodity/updateSortByCommodityId",params ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.$message({
                            message: '排序成功',
                            type: 'success'
                        });
                        this.showEdit[row.commodityId] = false;
                        this.searchRecommendCommodity();
                    } else {
                        this.$message.error('添加失败:'+msg);
                    }

                }).catch(err=>{
                        this.$message.error('网络错误');
                    }
                )
            },
            addCommodity() {
                this.showCommodity = true;
                this.search();
                let params = {
                    page: "1",
                    size: "999",
                    lessonType: 1
                };
                https.fetchPost('/commodityInfo/listByRecommend',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.recommendCommodity = [];
                        for(let i in this.recommendCommodityData) {
                            this.recommendCommodity.push(this.recommendCommodityData[i].commodityId);
                        }
                    }
                }).catch(err=>{
                        console.log(err)
                        this.loading = false;
                        this.$message.error('数据加载失败');
                    }
                )

            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue
                }
            },

            monthFormat(row, column, cellValue, index) {
              if (cellValue != null) {
                if(cellValue == -1) {
                  return "永久";
                } else {
                  return cellValue+"天";
                }
              } else {
                return cellValue;
              }
            },
            searchRecommendCommodity() {
                let params = {
                    orgCode: this.orgCode,
                    page: "1",
                    size: "999",
                    lessonType: 1
                };
                https.fetchPost('/auditionCommodity/qryList',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.recommendCommodityData = data.data.data.list;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err)
                        this.loading = false;
                        this.$message.error('数据加载失败');
                    }
                )
            },
            search(val) {
              if(this.selectedCategory.length > 0) {
                this.searchData.ccId = this.selectedCategory[this.selectedCategory.length-1];
              } else {
                this.searchData.ccId = "";
              }
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                this.searchData.size = this.pageSize;
                this.searchData.commodityStatus = 1;
                this.searchData.isView = 1;
                let params = this.searchData;
                https.fetchPost('/commodityInfo/selectListAll',params, "json" ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == 200) {
                        this.currentPageCommodity= [];
                        this.commodityData = data.data.data;
                        this.total = data.data.total
                        for(let index in this.commodityData) {
                            this.currentPageCommodity.push(this.commodityData[index].commodityId);
                        }
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }

                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            saveRecommendCommodity() {
                this.changeRecommendCommodity();
                let commodityIdString = "";
                for(let i in this.recommendCommodity) {
                    commodityIdString += this.recommendCommodity[i]+",";
                }
                commodityIdString = commodityIdString.substr(0,commodityIdString.length-1);
                let params = {
                    orgCode: this.orgCode,
                    commodityIdString:commodityIdString
                };

                https.fetchPost('/auditionCommodity/updateByCommodityId',params, "json" ).then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.showCommodity = false;
                        this.$refs["searchDate"].resetFields();
                        this.searchRecommendCommodity();
                        this.selectedCategory = [];
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }

                }).catch(err=>{
                        console.log(err)
                    }
                )

            },
          //加载本部分类
          loadCourseCategory() {
            console.log(11111111111)
            let params = {
              orgCode: this.$store.state.eblcuOrg
            };
            this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.categoryOptions = data.data.data;
                console.log(this.categoryOptions)
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }

            }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            });
          },
          changeCategory() {

          },
            changeCourse(val) {
                this.searchData.ccId = '';
                this.courseChild = this.courseChildData[val];
            },
          changeOrg(val) {
            this.searchData.orgCode = this.orgCode;
            this.searchRecommendCommodity();
          },
          selectOrg() {
            this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.org = data.data.data;
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }

            }).catch(err => {
                  console.log(err);
                  this.$message.error('网络错误');
                }
            );
          },
        },
        created: function () {
          this.orgCode =this.$store.state.orgCode;
          this.searchData.orgCode = this.orgCode;
          this.loginOrgCode = this.$store.state.orgCode;
          this.orgType = this.$store.state.orgType
          this.searchRecommendCommodity();
          this.loadCourseCategory();
          this.selectOrg();
        }
    }
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
    .line {
        text-align: center;
    }
    .edit-cell {
        width: 60%;
    }
</style>